import { render, staticRenderFns } from "./AccessLinkForm.vue?vue&type=template&id=c5f8609e&scoped=true&"
import script from "./AccessLinkForm.vue?vue&type=script&lang=js&"
export * from "./AccessLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f8609e",
  null
  
)

export default component.exports